import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { BizSharedModule } from '../../biz-shared.module';
import { LocationListComponent } from './location-list/location-list.component';
import { GetLastLocationComponent } from './get-last-location/get-last-location.component';
import { DoctorChemistLocationComponent } from './doctor-chemist-location/doctor-chemist-location.component';
import {AgmOverlays} from 'agm-overlays';
import {CommonModule} from '@angular/common';
import {
    MatButtonModule,
    MatIconModule, MatProgressBarModule,
    MatProgressSpinnerModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatTooltipModule
} from '@angular/material';
import {TimelineByDateRangeComponent} from './timeline-by-date-range/timeline-by-date-range.component';
import {NgxDaterangepickerMd} from 'ngx-daterangepicker-material';
import {AgmCoreModule, LAZY_MAPS_API_CONFIG, LazyMapsAPILoaderConfigLiteral} from '@agm/core';
import {AppConfigService} from '../../services/app-config.service';
import {UserLastLocationsComponent} from './user-last-locations/user-last-locations.component';
import {UserTimelineByDateComponent} from './user-timeline-by-date/user-timeline-by-date.component';

export function mapConfigFactory(configService: AppConfigService): LazyMapsAPILoaderConfigLiteral {

    return {
        apiKey: configService.mapApiKey
    };
}

@NgModule( {
    declarations: [ LocationListComponent, GetLastLocationComponent, DoctorChemistLocationComponent,
        TimelineByDateRangeComponent, UserLastLocationsComponent, UserTimelineByDateComponent ],
    imports: [
        AgmCoreModule.forRoot(),
        RouterModule.forChild([
            {
                path: 'list',
                component: LocationListComponent
            },
            {
                path: 'user-location',
                component: GetLastLocationComponent
            },
            {
                path: 'doctor-chemist-location',
                component: DoctorChemistLocationComponent
            },
            {
                path: 'timeline-by-multiple-dates',
                component: TimelineByDateRangeComponent
            },
            {
                path: 'user-last-locations',
                component: UserLastLocationsComponent
            },
            {
                path: 'user-timeline-by-date',
                component: UserTimelineByDateComponent
            }
        ]),
        BizSharedModule,
        AgmOverlays,
        AgmCoreModule,
        AgmOverlays,
        CommonModule,
        MatIconModule,
        MatProgressSpinnerModule,
        MatSortModule,
        MatTableModule,
        MatTabsModule,
        MatTooltipModule,
        MatButtonModule,
        MatIconModule,
        MatProgressBarModule,
        NgxDaterangepickerMd

    ],
    exports: [
        AgmCoreModule
    ],
    providers: [
        {
            provide: LAZY_MAPS_API_CONFIG,
            useFactory: mapConfigFactory,
            deps: [AppConfigService]
        }
    ]
} )
export class LocationModule {
}
